

import { TIcon } from "@/app/types/types";

const TextFieldResizeIcon = ({ color }: TIcon) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="22"
			height="22"
			viewBox="0 0 22 22"
			fill="none"
		>
			<path
				opacity="0.6"
				d="M21 1V1C21 12.0457 12.0457 21 1 21V21"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				
			/>
		</svg>
	);
};

export default TextFieldResizeIcon;
